// © Microsoft Corporation. All rights reserved.

export enum CookieConsentStatus {
    /**
     * Consent status has not been resolved yet.
     */
    Unknown,
    /**
     * Consent is required and is not yet provided.
     */
    Required,
    /**
     * Consent is not required. This could be because user is in a market where consent is not needed, or consent has already been provided.
     */
    NotRequired
}